import React from 'react';
import { ISchemaLevelObjectType } from 'utils/types';
import SnowflakeIcon from 'components/SnowflakeIcon';

interface ObjectNodeProps {
  name: string;
  data: any;
  objectType?: ISchemaLevelObjectType;
}

export default function ObjectNode(props: ObjectNodeProps): JSX.Element {
  const { name, data, objectType = 'table' } = props;

  return (
    <div className="w-full flex py-1 border border-gray-300 bg-gray-50 rounded-md text-gray-700 cursor-default px-2">
      <div className="min-w-[20px] w-5 mr-1">
        <SnowflakeIcon objectType={objectType} />
      </div>
      <div className="flex-1 flex items-center justify-between">
        <div className="max-w-[9.5rem] text-sm truncate">{name}</div>
        {/* Display the number of columns aligned to the right */}
        {data.columns !== undefined && (
          <div className="text-xs text-gray-500 ml-2 whitespace-nowrap">{Object.keys(data.columns).length} cols</div>
        )}
      </div>
    </div>
  );
}
